import { sweepPaymentMethodTypeLabel } from 'core/helpers/sweep-account';

/**
 * Pure helpers for the sweep-bind payment-method picker (#33155). Kept out of the component
 * so they can be unit-tested without Apollo/MUI (staff-fe has no MockedProvider test pattern).
 */

/**
 * Dropdown label for a sweep account payment method: the shared type label (bank name / card
 * brand) plus the last 4 and a "(default)" marker so the default is distinguishable in a flat
 * dropdown. The Sweep Account management list renders a deliberately different last-4 style
 * (see `manage-account.jsx`); only the type→label part is shared (`sweepPaymentMethodTypeLabel`).
 */
export const describePaymentMethod = (pm) =>
  `${sweepPaymentMethodTypeLabel(pm)} ****${pm.last4}${pm.isDefault ? ' (default)' : ''}`;

/**
 * Maps sweep payment methods to the `{ id, value }` option shape the core `Select` expects.
 * `id` is the Stripe payment-method id (the selected form value); `value` is the display label
 * the core Select renders — both in the open menu and, via its `renderValue`, in the closed
 * control. A bare MUI `<Select>` has no `renderValue`, which is why the selected value showed
 * blank before this was routed through the core component.
 */
export const buildSweepPaymentMethodOptions = (paymentMethods) =>
  (paymentMethods ?? []).map((pm) => ({ id: pm.id, value: describePaymentMethod(pm) }));
